export const WALLET_DEBITS_URL = "/internal/payments/wallet-debits";

export const WALLET_DEBITS_PAGE_SIZE = 20;

/** Limits of the backend DTO; the form refuses past them instead of letting the POST answer 400. */
export const WALLET_DEBIT_CONCEPT_MAX = 140;
export const WALLET_DEBIT_EXTERNAL_REFERENCE_MAX = 120;
export const WALLET_DEBIT_NOTE_MAX = 1000;

/**
 * Supporting files one upload may carry, and a debit may hold in total (backend
 * `MAX_WALLET_DEBIT_ATTACHMENTS*`).
 */
export const WALLET_DEBIT_ATTACHMENTS_PER_UPLOAD = 5;
export const WALLET_DEBIT_ATTACHMENTS_MAX = 10;

/** The description coloca-nest writes on the ledger leg of a debit — how a statement row is recognized. */
export const WALLET_DEBIT_LEDGER_DESCRIPTION = "coloca debit";
/** The `REVERSE` leg that gives a cancelled debit's amount back. */
export const WALLET_DEBIT_CANCELLED_LEDGER_DESCRIPTION = "coloca debit cancelled";
